import React from "react";
import AuthComponent from '../components/AuthComponent';
import {
    Container, Card, CardBody,
    CardTitle, CardSubtitle
} from 'reactstrap';
import { normalizeCountry } from "../utils/normalizeCountry";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const colorScale = (count) => {
    if (!count) return "#dddddd"; // Default color for no data
    if (count > 100) return "#1864ab";
    // if (count > 50) return "#4dabf7";
    if (count > 5) return "#4dabf7";
    return "#a5d8ff";
}

export default class StatsMap extends AuthComponent {

    getMemberCountsByISO = (users) => {
        const counts = {};
        for (let j = 0; j < users.length; j++) {
            if (!users[j].country || users[j].country === "" || users[j].country === "-") {
                // console.warn("Empty country for user:", users[j]);
                continue;
            }
            console.log("user's country:", users[j].country);
          // Normalize the country name
          const cleanName = normalizeCountry(users[j].country);
          if (!cleanName) {
            console.warn("Empty country name for user:", users[j]);
            continue;
          }
        //   console.log("country cleanName:", cleanName);
          counts[cleanName] = (counts[cleanName] || 0) + 1;
        }
        return counts;
    }
     
    render() {
        const memberCounts = this.getMemberCountsByISO(this.props.users || []); 

        return (
            <Container className="Statistics">
                <Card>
                    <CardBody>
                        <CardTitle>Dove viviamo?</CardTitle>
                        <CardSubtitle>Distribuzione dei parenti nel mondo</CardSubtitle>
                            <ComposableMap
                            projectionConfig={{ scale: 160 }}
                            width={800}
                            height={400}
                            style={{ width: "100%", height: "auto" }}
                            >
                                <Geographies geography={geoUrl}>
                                    {({ geographies }) =>
                                    geographies.map((geo) => {
                                        const countryName = geo.properties.name;
                                        const count = memberCounts[countryName];
                                        console.log("countryName:", countryName, "count:", count);
                                        return (
                                        <Geography
                                            key={geo.rsmKey}
                                            geography={geo}
                                            fill={colorScale(count)}
                                            stroke="#FFF"
                                            style={{
                                            default: { outline: "none" },
                                            hover: { outline: "none", fill: "#ffb703" },
                                            pressed: { outline: "none" },
                                            }}
                                        />
                                        );
                                    })
                                    }
                                </Geographies>
                            </ComposableMap>
                    </CardBody>
                </Card>
            </Container>
        );
    };
}

